/**
 * LiveSearch
 * ======================================
 * - load results via ajax
 */

 const INPUTS = '.js-LiveSearch'
 const PARENT = '.search-autocomplete'
 const ALL_BTN = '.js-LiveSearchButton'
 const MESSAGE = '.search-autocomplete__message'
 const ACTIVE_CLASS = 'livesearch-active'

 class LiveSearch {
   constructor() {
     this.inputs = document.querySelectorAll(INPUTS)
     this.ajaxUrl = '/app/themes/ipress/ajax/index.php'

     if (!this.inputs.length) {
       return false
     }

     this.inputs.forEach(el => {
       el.addEventListener('input', this.delay(this.inputHandler, 500), false)
     })
  }

  delay(fn, ms) {
    let timer = 0

    return function(...args) {
      clearTimeout(timer)
      timer = setTimeout(fn.bind(this, ...args), ms || 0)
    }
  }

  setAllBtnHref = (widget, value) => {
    const all_btn = widget.querySelector(ALL_BTN)
    const base_url = all_btn.getAttribute('data-base-url')
    const newHref = base_url +''+ encodeURI(value)

    all_btn.setAttribute('href', newHref)
  }

  setMessage = (widget, type) => {
    const message = widget.querySelector(MESSAGE)

    if(type == 'hide') {
      message.classList.add('hide')
    } else {
      const text = message.getAttribute('data-'+type)
      message.innerHTML = text

      message.classList.remove('hide')
    }
  }

   inputHandler = (e) => {
    const input = e.currentTarget || e.target
    const searchString = input.value
    const widget = input.closest(PARENT)

    if(searchString != "") {
      widget.classList.add('livesearch-loading')

      this.setAllBtnHref(widget, searchString)
      this.setMessage(widget, 'loading')
      widget.classList.add(ACTIVE_CLASS)

      this.ajaxHandler(widget, searchString)
    } else {
      this.setAllBtnHref(widget, searchString)

      widget.classList.remove(ACTIVE_CLASS)
    }
   }

   ajaxHandler = (widget, searchString) => {
    const widget_results = widget.querySelector('.search-autocomplete__in')

		const xhr = new XMLHttpRequest()
    xhr.parent = this;
		xhr.open('POST', this.ajaxUrl, true)
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
		xhr.send("action=liveSearch&lang="+lang+"&s="+searchString)

		xhr.onreadystatechange = function() {
			if (xhr.readyState === 4) {

				// ok
				if (xhr.status === 200) {
          const response = JSON.parse(xhr.response)

          widget_results.innerHTML = response.html
          widget.classList.remove('livesearch-loading')

          if(response.html && response.count > 0){
            this.parent.setMessage(widget, 'hide')
            widget.classList.remove('livesearch-no-results')
          } else {
            this.parent.setMessage(widget, 'empty')
            widget.classList.add('livesearch-no-results')
          }
				}
				// error
				else {
					console.log('ajaxForm error!', xhr)
				}
			}
		}
	}
 }

 new LiveSearch()
